export default {
  path: '/meter-pieces',
  component: () =>
    import(
      '@/components/pages/MeterPieces/MeterPieces.vue'
    )
}
